const FLORIDA_AT_END = /(?:^|[\s,])(?:FL|FLORIDA)\.?(?:[\s,]*\d{5}(?:-\d{4})?)?(?:[\s,]+(?:USA|US|UNITED STATES))?[\s,.]*$/i;

export function namesPalmBeach(district: string): boolean {
  return district.toUpperCase().includes("PALM BEACH");
}

/** The School District of Palm Beach County: a district that names Palm Beach and an address in Florida. */
export function isPalmBeachCounty(district: string, address: string): boolean {
  return namesPalmBeach(district) && FLORIDA_AT_END.test(address.trim());
}
